import { render, staticRenderFns } from "./FormularioTrekking.vue?vue&type=template&id=813f04de&scoped=true&"
import script from "./FormularioTrekking.vue?vue&type=script&lang=ts&"
export * from "./FormularioTrekking.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioTrekking.vue?vue&type=style&index=0&id=813f04de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813f04de",
  null
  
)

export default component.exports